import { Colors, ContentSpacing, Fonts } from 'elc-base-theme';

export const SelectedSizeBoxTheme = `
    background-color: ${Colors.primary900};
    color: ${Colors.white};
`;

export const SelectedFilterButtonTheme = `
    background-color: ${Colors.black};
    border-color: ${Colors.black};
    color: ${Colors.white};
    border-radius: 4px;
    border: 1px solid;
`;

export const UnselectedFilterButtonTheme = `
    background-color: ${Colors.white};
    border-color: ${Colors.black};
    color: ${Colors.black}
    border-radius: 4px;
    border: 1px solid;
`;

export const SizeBoxTheme = `
    border-color: ${Colors.black};
`;

export const UppercaseTheme = `
    text-transform: uppercase;
`;

export const LowercaseTheme = `
    text-transform: lowercase;
`;

export const FilterListItemTheme = `
    color: ${Colors.primary700};
    ${UppercaseTheme}
`;
export const SelectedFilterListItemTheme = `
    ${UppercaseTheme}
`;

export const SelectedCategoryTheme = `
    color: ${Colors.blackHighEmphasis}
`;

export const UnselectedCategoryTheme = `
    color: ${Colors.blackMediumEmphasis}
`;

export const shadeRemoveIconTheme = `
    stroke: ${Colors.white};
    filter: drop-shadow(0 0 1px ${Colors.primary800});
`;

export const sizeLabelThemeDropdown = `
    color: ${Colors.blackMediumEmphasis};
    font-family: ${Fonts.robotoMedium};
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.25px;
    line-height: ${ContentSpacing.space24};
`;

export const sizePickerLabelThemeDropdown = `
    color: ${Colors.blackMediumEmphasis};
    font-family: ${Fonts.roboto};
    font-weight: normal;
    line-height: ${ContentSpacing.space20};
`;

export const sizeLabelTheme = `
    font-weight: bold;
`;

export const sizePickerLabelTheme = `
    font-weight: bold;
    line-height: 1;
    color: ${Colors.blackDisabledEmphasis};
`;

export const SecondaryTextTheme = `
    color: ${Colors.primary700};
`;

export const BorderTopTheme = `
    border-top: 1px solid ${Colors.primary400};
`;

export const BorderBottomTheme = `
    border-bottom: 1px solid ${Colors.primary400};
`;

export const MainColumnTheme = `
    background: ${Colors.primary100};
`;

export const SideColumnTheme = `
    background: ${Colors.white};
    box-shadow: ${ContentSpacing.space4} 0 ${ContentSpacing.space4} 0 ${Colors.blackLightEmphasis};
`;

export const StickyRowTheme = `
    background: ${Colors.white};
    box-shadow: 0 1px 0 0 ${Colors.blackLightEmphasis};
`;

export const ColorWhiteTheme = `
    color: ${Colors.white};
`;

export const BackgroundWhiteTheme = `
    background: ${Colors.white};
`;

export const IconStrokeTheme = `
    stroke: ${Colors.primary700};
    stroke-width: 2px;
`;

export const ColumnHeadingTheme = `
    font-weight: bold;
`;

export const FilterHeadingTheme = `
    font-weight: normal;
    text-transform: uppercase;
`;

export const ProductBriefShadowTheme = `
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
    &:hover {
        box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.2);
    }
`;

export const ProductDisplayNameTheme = `
    a {
        text-decoration: none;
        color: ${Colors.primary900};

        &:hover {
            text-decoration: underline;
        }
    }
`;

export const ProductSublineNameTheme = `
    color: ${Colors.primary900};
`;

export const ProductDescriptionTheme = `
    color: ${Colors.primary900};
`;

export const ProductPriceTheme = `
    font-weight: 600;
`;

export const ProductDiscountedPriceTheme = `
    color: ${Colors.primary400};
    text-decoration: line-through;
`;

export const HorizontalFilterButtonTheme = `
    text-transform: capitalize;
    text-align: left;

    [dir='rtl'] & {
        text-align: right;
    }
`;

export const ProductBadgeWrapperTheme = `
    background-color: ${Colors.white};
    border-style: solid;
    border-color: $dim-grey;
    color: $dim-grey;
    font-weight: bold;
    font-size: 0.9em;
    text-transform: uppercase;
    letter-spacing: -1px;
    line-height: 1;
    box-shadow: 0 0 0 2px $color-white;
`;

export const ProductBadgeTextTheme = `
    font-size: 8px;
    line-height: 1;
    letter-spacing: 0;
`;

export const ProductPromoMessageTheme = `
    background: ${Colors.primary200};
`;

export const ProductCTAWrapperTheme = `
    background: ${Colors.white};
    box-shadow: 0 0 4px 1px rgba(0,0,0,.2);
`;

export const MobileSelectTheme = `
    font-family: ${Fonts.robotoMedium};
    font-size: 14px;
    color:  ${Colors.primary700};
`;

export const MobileSelectArrowTheme = `
    font-size: 12px;
    line-height: 1;
    text-align: center;
    color:  ${Colors.primary700};
    border-left-style: solid;
    border-left-color: ${Colors.primary700};
`;

export const StickyAddToBagContainerTheme = `
    text-align: center;
    background: ${Colors.white};
`;

export const ShadeOverlayHeaderTheme = `
    font-size: 16px;
    font-weight: 700;
`;

export const BackgroundGrayTheme = `
    background-color: ${Colors.primary100};
`;

export const ShadeSliderPaginationTheme = `
    border-bottom: 1px solid ${Colors.primary300};
`;

export const ShadeSliderDotTheme = `
    p {
        font-weight: 700;
        color: ${Colors.primary500};
    }

    .slick-active & {
        &::before {
            display: block;
            font-family: 'slick';
            font-size: 24px;
            line-height: 0;
            content: '•';
            text-align: center;
            color: ${Colors.primary500};
        }
        p {
            color: ${Colors.primary800};
        }
    }
`;

export const InventoryStatusMessageTheme = `
    color: ${Colors.info};
`;

export const ScrollSliderDotTheme = `
    &::before {
        font-family: 'slick';
        font-size: 32px;
        line-height: 0;
        content: '•';
        color: ${Colors.primary300};
        text-align: center;
    }

    &.active {
        &::before {
            color: ${Colors.primary600};
        }
    }
`;

export const ShadeItemTheme = `
    border-top: 1px solid ${Colors.primary300};
    border-bottom: 1px solid ${Colors.primary300};
    font-size: 20px;
`;

export const ColorFamilyRowTheme = `
    font-weight: 700;
`;

export const StyledOkIconTheme = `
    fill: ${Colors.white}
`;

export const ShadeOverlayButtonTheme = `
    background-color: ${Colors.white};
    border: 1px solid ${Colors.black};
    color: ${Colors.black};
    border-radius: 5px;

    &:hover {
        background-color: ${Colors.white};
    }
    font-weight: 700;
`;
export const SidebarDetailsHeadingTheme = `
    font-weight: 700;
`;

export const SelectedSwatchTheme = `
    border: 2px solid ${Colors.black}
`;

export const StickyAddToBagProductInfoTheme = `
    font-weight: 700;
`;

export const AutoReplenishDropdownTheme = `
    .elc-dropdown-wrapper {
        border: 0;
    }

    .elc-dropdown-arrow {
        border: 0;
    }

    .elc-dropdown-options {
        border: 0;
    }
`;

export const StyledAnchorTheme = `
    color: ${Colors.primary500};
    &:hover {
        font-weight: bold;
    }
`;

export const smooshImageTheme = (hexValue: string) => `
    .elc-img {
        background-color: ${hexValue};
    }
`;

export const ProductZoomButtonTheme = `
    background-color: transparent;
    border: 0;
`;
